import { JourneyStepResponse } from '../../interfaces/journey.interface';
import { DEFAULT_BUNDLED_ERROR_MESSAGE, mapJourneyError } from './journey-error-messages.bundle';

const DEFAULT_ERROR = DEFAULT_BUNDLED_ERROR_MESSAGE;
const USE_RAW_PING_ERRORS = false;
const CALLBACK_ERROR_MESSAGE_TYPES = new Set(['1', '2']);

export function resolveJourneyErrorMessage(raw: unknown): string {
  const rawText = typeof raw === 'string' ? raw.trim() : '';
  if (USE_RAW_PING_ERRORS && rawText) {
    return rawText;
  }

  const normalized: string | null = rawText || null;
  return mapJourneyError(normalized) || DEFAULT_ERROR;
}

/**
 * Returns the translated step-level callback error/warning when present.
 * Prefers messageType 2 over messageType 1.
 */
export function extractJourneyStepError(step: JourneyStepResponse | null | undefined): string | null {
  const callbacks = step?.callbacks ?? [];
  const textOutputs = callbacks.filter((cb) => cb.type === 'TextOutputCallback');

  const ranked = textOutputs
    .map((cb) => {
      const rawMessageType = cb.output?.find((output) => output.name === 'messageType')?.value;
      const messageType = String(rawMessageType ?? '0');
      const message = cb.output?.find((output) => output.name === 'message')?.value;
      const rank = messageType === '2' ? 2 : messageType === '1' ? 1 : 0;
      return { messageType, message, rank };
    })
    .filter((entry) => entry.rank > 0 && typeof entry.message === 'string' && entry.message.trim().length > 0)
    .sort((a, b) => b.rank - a.rank);

  if (!ranked.length) {
    return null;
  }

  return resolveJourneyErrorMessage(ranked[0].message);
}

export function isJourneyCallbackErrorType(messageType: string): boolean {
  return CALLBACK_ERROR_MESSAGE_TYPES.has(String(messageType ?? '0'));
}

export function extractTransportErrorMessage(err: any): string {
  const raw =
    err?.error?.error?.message ??
    err?.error?.message ??
    err?.message ??
    null;

  return resolveJourneyErrorMessage(raw);
}
